/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionReportUpdate } from '../../models/subscription-report-update';

export interface UpdateSubscriptionReport$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected report entry
 */
  reportUid: string;
  
    /**
     * The subscription report entry update object
     */
    body: SubscriptionReportUpdate
}

export function updateSubscriptionReport(http: HttpClient, rootUrl: string, params: UpdateSubscriptionReport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateSubscriptionReport.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('reportUid', params.reportUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateSubscriptionReport.PATH = '/custom/subscriptions/{uid}/reports/{reportUid}';
